module.exports = __webpack_public_path__ + "static/media/icon_arrow_right_white.002359ca.svg";